module.exports = __webpack_public_path__ + "img/cach-gold.602b1fee.svg";